'use strict';

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getField = undefined;
exports.setField = setField;
exports.processFields = processFields;
exports.cleanInput = cleanInput;
exports.keyValueObjectToArray = keyValueObjectToArray;
exports.keyValueArrayToObject = keyValueArrayToObject;

var _FormField = require('./FormField');

exports.getField = _FormField.getField;

function setField(fields, name, value) {
  if (!fields) {
    return null;
  }

  var tree = name.replace(/\]/g, '').split(/[\.\[]/);

  if (tree.length == 1) {
    fields[tree[0]] = value;
    return fields[tree[0]];
  } else {
    if (fields[name]) {
      fields[name] = value;
      return fields[name];
    } else {
      return setField(fields[tree[0]], tree.slice(1).join('.'), value);
    }
  }
}

function processFields(inputFields) {
  var fields = {};
  var keyValueFields = [];
  var fieldArrayFields = [];
  var displayOnlyFields = [];
  var stripFields = [];
  Object.keys(inputFields).forEach(function (fieldName) {
    if (inputFields[fieldName].type === "keyvalue") {
      keyValueFields.push(fieldName);
      Object.keys(inputFields[fieldName].config).forEach(function (name) {
        fields[fieldName + '.' + name] = inputFields[fieldName].config[name];
      });
    } else {
      if (inputFields[fieldName].type === "fieldarray") {
        fieldArrayFields.push(fieldName);
        inputFields[fieldName].config && Object.keys(inputFields[fieldName].config).forEach(function (subField) {
          if (inputFields[fieldName].config[subField].displayOnly) {
            displayOnlyFields.push(fieldName + ".*." + subField);
          }

          if (inputFields[fieldName].config[subField].strip) {
            stripFields.push(fieldName + ".*." + subField);
          }
        });
      }

      if (inputFields[fieldName].displayOnly) {
        displayOnlyFields.push(fieldName);
      }

      if (inputFields[fieldName].strip) {
        stripFields.push(fieldName);
      }

      fields[fieldName] = inputFields[fieldName];
    }
  }); // console.log('Strip Fields: ', stripFields)

  return {
    fields: fields,
    keyValueFields: keyValueFields,
    fieldArrayFields: fieldArrayFields,
    displayOnlyFields: displayOnlyFields,
    stripFields: stripFields
  };
}

function cleanInput(obj, initialValues) {
  var ignore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";

  if (obj instanceof Array) {
    return obj.map(function (o) {
      return cleanInput(o);
    });
  }

  if (obj instanceof Object) {
    var result = {};
    Object.keys(obj).forEach(function (k) {
      // console.log('Cleaning', (prefix+"."+k))
      if (k !== '__typename' && !ignore.includes(prefix + "." + k) && (initialValues === undefined || obj[k] !== initialValues[k])) {
        var cleaned = cleanInput(obj[k], initialValues && initialValues[k], ignore, prefix + "." + k);

        if (cleaned) {
          if (!(cleaned instanceof Object) || Object.keys(cleaned).length !== 0) {
            result[k] = cleaned;
          }
        } else {
          result[k] = cleaned;
        }
      }
    });
    return result;
  }

  return obj;
}

function keyValueObjectToArray(input, keyValueFields) {
  keyValueFields && keyValueFields.forEach(function (fieldName) {
    var field = (0, _FormField.getField)(input, fieldName);

    if (field) {
      var newValue = [];
      Object.keys(field).forEach(function (key) {
        var value = field[key].toString();
        newValue.push({
          key: key,
          value: value
        });
      });
      setField(input, fieldName, newValue);
    }
  });
}

function keyValueArrayToObject(input, keyValueFields) {
  // console.log(input, keyValueFields)
  keyValueFields && keyValueFields.forEach(function (fieldName) {
    var field = (0, _FormField.getField)(input, fieldName);

    if (!field) {// console.log(fieldName)
    } else {
      var newValue = {};
      field.forEach(function (_ref) {
        var key = _ref.key,
            value = _ref.value;
        newValue[key] = value;
      });
      setField(input, fieldName, newValue);
    }
  });
}